import * as React from "react";
const SVGComponent = (props) => (
    <svg width="21" height="23" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 6.28906C14 4.96298 13.4732 3.69121 12.5355 2.75353C11.5979 1.81585 10.3261 1.28906 9 1.28906C7.67392 1.28906 6.40215 1.81585 5.46447 2.75353C4.52678 3.69121 4 4.96298 4 6.28906C4 12.1224 1.5 13.7891 1.5 13.7891H16.5C16.5 13.7891 14 12.1224 14 6.28906Z" stroke="black" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

);
export default SVGComponent;
